import { render, staticRenderFns } from "./BookingTalentList.vue?vue&type=template&id=0f5f94e4"
import script from "./BookingTalentList.vue?vue&type=script&lang=js"
export * from "./BookingTalentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports